module.exports = __webpack_public_path__ + "static/media/agricultural5.818f3647.jpg";